module.exports = __webpack_public_path__ + "static/project-15a-faa50615cdd196c8a6f9b8d28e420722.png";